import { jsx as _jsx } from "react/jsx-runtime";
import { uploadItemImage } from '../../api/item-images';
import { EntityBulkUploadModal } from '../EntityBulkUploadModal/EntityBulkUploadModal';
export const ItemsBulkUploadModal = (props) => (_jsx(EntityBulkUploadModal, Object.assign({}, props, { title: "Bulk Upload Item Images", upload: uploadItemImage, uploadView: "percentOnly", resultView: "summaryOnly" })));
